"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipsRequests = void 0;
const Requests_1 = require("../../Requests");
const InvitationRequests_1 = require("./InvitationRequests");
class MembershipsRequests extends Requests_1.Requests {
    constructor(session, profileId) {
        super(session);
        this.profileId = profileId;
        this.resource = `profiles/${this.profileId}/memberships`;
    }
    invite(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const invite = new InvitationRequests_1.InvitationRequests(this.session);
            return invite.invite(this.profileId, data);
        });
    }
}
exports.MembershipsRequests = MembershipsRequests;
//# sourceMappingURL=MembershipsRequests.js.map